import { EntityPropList } from '@/common/entities/entityProp/EntityPropList';
import { IncDataSrcList } from '@/common/entities/incDataSrc/IncDataSrcList';
import { IncListList } from '@/common/entities/incList/IncListList';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityFormMode } from '@/common/entityFramework/enumerations/EntityFormMode';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ValList } from '@/common/val/ValList';
import { useEffect } from 'react';

export const GlobalFilterDetail = () => {
  const { entityObj, setEntityFormMode } = useEntityMgr();
  const { navState, assign } = useNavState();
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  useEffect(() => {
    if (navState.entityId) return;
    rsrc.one(module, 'FILTER', { expr: ExprUtils.whereParams('global', true) }).then((filter) => {
      assign('entityId', filter.id);
      setEntityFormMode(EntityFormMode.VIEW);
    });
  }, [navState.entityId]);

  if (!navState.entityId) {
    return null;
  }

  const tabSpecs = [{ id: 'infoTab', label: 'Info', content: <EntityForm /> }];

  tabSpecs.push(
    { id: 'incDataSrcTab', label: 'Inclusion Data Sources', content: <IncDataSrcList filterId={entityObj.id} /> },
    { id: 'incListTab', label: 'Inclusion Lists', content: <IncListList filterId={entityObj.id} /> },
  );

  tabSpecs.push(
    {
      id: 'propTab',
      label: 'Properties',
      content: <EntityPropList parentEntity="FILTER" parentEntityObj={entityObj} />,
    },
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="FILTER" parentEntityId={entityObj.id} /> },
  );

  return <EntityDetail tabSpecs={tabSpecs} />;
};
